import { Component, OnInit } from '@angular/core';
import { ModalService } from '@app/services/modal.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modal-upload-mail-error',
  templateUrl: './modal-upload-mail-error.component.html',
  styleUrls: ['./modal-upload-mail-error.component.scss']
})
export class ModalUploadMailErrorComponent implements OnInit {

  public urlCF: string;

  constructor(
    public modalService: ModalService
  ) {
    this.urlCF = environment.covifacturaLandingUrl;
   }

  ngOnInit() {
  }

}
